import Phaser from "phaser";
import type { BakeResult } from "./types";

export function textureKey(
  packId: string,
  spriteId: string,
  affiliationKey: string,
): string {
  return `art:${packId}:${spriteId}:${affiliationKey}`;
}

/**
 * Upload baked RGBA into Phaser texture cache (nearest for pixel look).
 */
export function ensurePhaserTexture(
  scene: Phaser.Scene,
  key: string,
  baked: BakeResult,
): string {
  if (scene.textures.exists(key)) return key;

  const canvas = document.createElement("canvas");
  canvas.width = baked.width;
  canvas.height = baked.height;
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("2d context unavailable");
  const imageData = ctx.createImageData(baked.width, baked.height);
  imageData.data.set(baked.rgba);
  ctx.putImageData(imageData, 0, 0);

  scene.textures.addCanvas(key, canvas);
  const tex = scene.textures.get(key);
  tex.setFilter(Phaser.Textures.FilterMode.NEAREST);
  return key;
}

/** DOM/data-URL for HUD icons without a Phaser scene. */
export function bakeToDataUrl(baked: BakeResult, scale = 2): string {
  const canvas = document.createElement("canvas");
  canvas.width = baked.width * scale;
  canvas.height = baked.height * scale;
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("2d context unavailable");
  ctx.imageSmoothingEnabled = false;
  const src = document.createElement("canvas");
  src.width = baked.width;
  src.height = baked.height;
  const sctx = src.getContext("2d");
  if (!sctx) throw new Error("2d context unavailable");
  const imageData = sctx.createImageData(baked.width, baked.height);
  imageData.data.set(baked.rgba);
  sctx.putImageData(imageData, 0, 0);
  ctx.drawImage(src, 0, 0, canvas.width, canvas.height);
  return canvas.toDataURL("image/png");
}
